<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang'; 

  import { datepicker } from 'vue-strap';
  import { checkbox } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';

  export default {
    components: { datepicker, CabecalhoRelatorio, TelaCheia, checkbox },
    data() {
      return {
        filtros: {
          idProjeto: '',
          idRubrica: '',
          idSubrubrica: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
          idMetaEtapa: '',
          idConta: '',
          rendimento: 0,
        },
        projetos: [],
        relatorio: [],
        saldoAnterior: 0,
        resumo: {},
        projeto: null,
        configuracao: this.$storage.configuracao(),
        dataInicio: '',
        dataFim: '',
        rubricas: [],
        subrubricas: [],
        metaEtapas: [],
        contas: [],
        rubrica: null,
        subrubrica: null,
        metaEtapa: null,
        conta: null, 
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissaoAcessoEspecial()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contasProjeto(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      listaDeMetaEtapas() {
        return projetoServico
          .metaEtapasProjeto(this.filtros.idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .rubricasProjetoAcessoEspecial(this.filtros.idProjeto, this.filtros.idMetaEtapa)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';

        if (this.projetoSelecionado.utilizarMetaEtapaProjeto && this.filtros.idMetaEtapa !== '' && this.filtros.idRubrica === '') {
          this.subrubricas = [];
          return;
        }

        return projetoServico
          .subrubricasProjetoAcessoEspecial(this.filtros.idProjeto, this.filtros.idRubrica, this.filtros.idMetaEtapa)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarProjeto();
        this.setarConta();
        this.setarRubrica();
        this.setarSubrubrica();
        this.setarMetaEtapa();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.lancamentos(this.filtros)
          })
          .then(resultado => {
            this.relatorio = resultado.lancamentos;
            this.saldoAnterior = resultado.saldoAnterior;
            this.resumo = resultado.resumo;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = {};
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar-excel').button('loading');

            return relatorioServico.lancamentosExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');
            
            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      saldoParcial(indice) {
        return this.saldoAnterior + this.relatorio.reduce((total, lancamento, i) => {
          if (i > indice) return total;

          if (lancamento.creditoDebito === 1) {
            return total + lancamento.valor;
          } else {
            return total - lancamento.valor;
          }
        }, 0);
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null; 
      },
      setarConta() {
        const idConta = this.filtros.idConta;

        this.conta = idConta ? this.contas.find(c => c.id == idConta) : null;
      },
      setarRubrica() {
        const idRubrica = this.filtros.idRubrica;

        this.rubrica = idRubrica ? this.rubricas.find(r => r.id == idRubrica) : null;
      },
      setarSubrubrica() {
        const idSubrubrica = this.filtros.idSubrubrica;

        this.subrubrica = idSubrubrica ? this.subrubricas.find(s => s.id == idSubrubrica) : null;
      },
      setarMetaEtapa() {
        const idMetaEtapa = this.filtros.idMetaEtapa;

        this.metaEtapa = idMetaEtapa ? this.metaEtapas.find(me => me.idProjetoMetaEtapa == idMetaEtapa) : null;
      },
      formaPagamento(tipo) {
        switch (tipo) {
          case 0:
            return 'Cheque';
            break;
          case 1:
            return 'Boleto';
            break;
          case 2:
            return 'Dep. cheque';
            break;
          case 3:
          case 4:
          case 7:
            return 'Depósito';
            break;
          case 5:
            return 'Boleto';
            break;
          case 6:
            return 'Ordem pgto';
            break;
          default:
            return '---';
            break;
        }
      },
      ocultarRelatorio() {
        this.relatorio = [];
      },
      saldoDisponivel() {
        const saldoParcial = this.saldoParcial(this.relatorio.length - 1);
        
         let total = saldoParcial - this.resumo.contaPagar - this.resumo.provisaoPagar - this.resumo.provisaoCompras;
         
        if (this.resumo.exibirValorAplicRelFin || this.resumo.utilizarRendimento) {
           total += this.resumo.saldoAplicacao;
         }
         
         return total;
      },
      totalResumo() {
        let total = this.saldoDisponivel();
        
        if (this.configuracao.incluirAReceberCalculoSaldo) {
          total += this.resumo.contaReceber + this.resumo.provisaoReceber; 
        }
        
        return total;
      }
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;

        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
      mostrarResumo() {
        return !this.filtros.idRubrica && !this.filtros.idSubrubrica && !this.filtros.idMetaEtapa;  
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Lançamentos Financeiros`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);

        _this.filtros.idMetaEtapa = '';
        _this.filtros.idConta = '';
        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';

        if (_this.configuracao.filtrarLancamentoContaCorrenteWeb) {
          _this.listaContas(this.value);
        }

        if (_this.projetoSelecionado.utilizarMetaEtapaProjeto) {
          _this.listaDeMetaEtapas();
        }

        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    },
    watch: {
      'filtros.rendimento': 'ocultarRelatorio',
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="configuracao.filtrarLancamentoContaCorrenteWeb">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="conta">Conta</label>

                <select id="conta"
                        class="form-control"
                        v-model="filtros.idConta">
                  <option value="">Selecione...</option>
                  <option :value="conta.idConta" v-for="conta in contas">{{ conta.nomeConta }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" v-if="projetoSelecionado.utilizarMetaEtapaProjeto">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="metaEtapa">Meta Etapa</label>

                <select id="metaEtapa"
                        class="form-control"
                        v-model="filtros.idMetaEtapa"
                        @change="listaDeRubricas(); listaDeSubrubricas();">
                  <option value="">Selecione...</option>
                  <option :value="metaEtapa.idProjetoMetaEtapa" v-for="metaEtapa in metaEtapas">{{ metaEtapa.meta.nome }} {{ metaEtapa.etapa.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="checkbox">
                  <checkbox v-model="filtros.rendimento" value="1" type="success" true-value="1" false-value="0">
                    Mostrar rendimento líquido (Não exibir lançamentos de aplicação e resgate)
                  </checkbox>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button 
                id="gerar"
                type="button" 
                class="btn btn-primary" 
                @click="gerar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i> 
              Gerar relatório
            </button>
            <button 
                id="gerar-excel"
                type="button" 
                class="btn btn-primary" 
                @click="gerarExcel"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i> 
              Gerar relatório em excel
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Lançamentos Financeiros" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th class="text-right">Período</th>
                    <th class="text-right">Saldo anterior (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="no-border-right">{{ projeto.nomeProjeto}}</td>
                    <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                    <td :class="['text-right no-border-left', saldoAnterior > 0 ? 'text-primary' : 'text-danger']">{{ saldoAnterior | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>
            
              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Data</th>
                    <th>CPF/CNPJ</th>
                    <th>Histórico</th>
                    <th>Forma pgto.</th>
                    <th>Documento Receber/Pagar</th>
                    <th class="text-center">Valor (R$)</th>
                    <th class="text-center">Saldo parcial (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lancamento, index) in relatorio">
                    <td>{{ lancamento.idLancamento }}</td>
                    <td>{{ lancamento.data | formatarData }}</td>
                    <td>{{ lancamento.cpfCnpj || '---' }}</td>
                    <td>{{ lancamento.historico }} {{ lancamento.nomeSubrubrica ? ` - ${lancamento.nomeSubrubrica}` : '' }} {{ lancamento.complemento ? ` - ${lancamento.complemento}` : '' }}</td>
                    <td>{{ formaPagamento(lancamento.formaPagamento) }}</td>
                    <td>{{ lancamento.documentoReceberPagar || '---' }}</td>
                    <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{ lancamento.creditoDebito === 1 ? '' : '-' }} {{ lancamento.valor | formatarNumero }}</td>
                    <td :class="['text-right', saldoParcial(index) > 0 ? 'text-primary' : 'text-danger']">{{ saldoParcial(index) | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>
              
              <p class="text-danger small">* Valores referente a: {{ dataInicio }} a {{ dataFim }}</p>

              <table class="table relatorio table-bordered" v-if="mostrarResumo">
                <thead>
                  <tr>
                    <th class="text-right" v-if="resumo.exibirValorAplicRelFin">{{ this.filtros.rendimento == 1 ? "Rend. líquido" : "Aplicado"}} </th>
                    <th class="text-right">Contas a pagar</th>
                    <th class="text-right">Impostos a pagar</th>
                    <th class="text-right">Provisões a pagar</th>
                    <th class="text-right">Saldo disponível</th>
                    <th class="text-right">Contas a receber</th>
                    <th class="text-right">Provisão a receber</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="text-right text-primary" v-if="resumo.exibirValorAplicRelFin">
                    {{ resumo.saldoAplicacao | formatarNumero }}
                  </td>
                  <td class="text-right text-danger">{{ '-' }}{{ resumo.contaPagar | formatarNumero }}</td>
                  <td class="text-right text-danger">
                    {{ '-' }}{{ (configuracao.infoProvLiquidaRelExtProj ? (resumo.provisaoPagar + resumo.provisaoReceber) : resumo.provisaoPagar) | formatarNumero }}
                  </td>
                  <td class="text-right text-danger">{{ '-' }}{{ resumo.provisaoCompras | formatarNumero }}</td>
                  <td :class="['text-right', saldoDisponivel() >= 0 ? 'text-primary' : 'text-danger']">{{ saldoDisponivel() | formatarNumero }}</td>
                  <td class="text-right text-primary">{{ resumo.contaReceber | formatarNumero }}</td>
                  <td class="text-right text-primary">{{ resumo.provisaoReceber | formatarNumero }}</td>
                  <td :class="['text-right', totalResumo() >= 0 ? 'text-primary' : 'text-danger']">{{ totalResumo() | formatarNumero }}</td>
                </tr>
                </tbody>
              </table>
              
              <p class="small text-danger" v-if="!mostrarResumo">
                * O resumo dos saldos não é exibido quando o filtro por meta/etapa, ou rubrica, ou subrubrica estiver
                selecionado. Para exibir o resumo dos saldos emita o relatório novamente, filtrando apenas pelo período
                e/ou conta.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acesso-especial/relatorio/componentes/Lancamentos.vue